import { BlockBorderProps } from "@store/Library/Components/Common/Block/Block";

export const defaultBorderProps: BlockBorderProps = {
    width: "1px",
    type: "solid",
    color: "common.border",
};
